<template>
    <div class="product-item">
        <div class="image-box">
            <div class="image" :style="'background-image: url('+src+');background-repeat: no-repeat;'"></div>
        </div>
        <div class="bottom">
            <p>
                {{title}}
                <span>更多</span>
            </p>
        </div>
        <a :href="'/product-item/'+title">

        </a>
    </div>
</template>
<script>
export default {
  name: 'product-item',
  props: ['src', 'title']
}
</script>
<style scoped>
    .product-item a {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height: 100%;
        display:block;
    }
    .product-item{
        width:360px;
        height: 290px;
        background-color: #ffffff;
        float: left;
        margin-left: 45px;
        margin-bottom: 50px;
        position: relative;
    }

    .product-item .image-box{
        width:360px;
        height:226px;
        border-radius: 5px 5px 0 0;
        overflow: hidden;
    }

    .product-item .image-box .image{
        width: 360px;
        height: 226px;
        background-size: cover;
        transition: all 0.5s;
    }

    .product-item:hover .image-box .image{
         -webkit-transform: scale(1.25, 1.25);
         transform: scale(1.25, 1.25);
    }

    .product-item:first{
        margin-left: 0;
    }

    body{
        background-color: #efefef;
    }

    .product-item p {
        padding:22px;
        margin:0;
    }

    .product-item span{
        color:#7f7f7f;
        position: absolute;
        right: 35px;
    }

    .product-item:hover span
    {
        color:#FBAE38;
    }

    .product-item span:after{
        content: "";
        position: absolute;
        margin-left: 10px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 0 6px 6px;
        border-color: transparent transparent transparent #7f7f7f;
        top: 30%;
    }

    .product-item:hover span:after{
        border-color: transparent transparent transparent #FBAE38;
        -webkit-animation: linkGo .5s alternate infinite ease-in both;
        animation: linkGo .5s alternate infinite ease-in both;
    }

    @-moz-keyframes linkGo {
        0% {
            top: 50%;
            transform: translateX(0px) translateY(-50%);
        }

        100% {
            top: 50%;
            transform: translateX(5px) translateY(-50%);
        }
    }

    @-o-keyframes linkGo {
        0% {
            top: 50%;
            transform: translateX(0px) translateY(-50%);
        }

        100% {
            top: 50%;
            transform: translateX(5px) translateY(-50%);
        }
    }

    @-webkit-keyframes linkGo {
        0% {
            top: 50%;
            -webkit-transform: translateX(0px) translateY(-50%);
            transform: translateX(0px) translateY(-50%);
        }

        100% {
            top: 50%;
            -webkit-transform: translateX(5px) translateY(-50%);
            transform: translateX(5px) translateY(-50%);
        }
    }

    @keyframes linkGo {
        0% {
            top: 50%;
            -webkit-transform: translateX(0px) translateY(-50%);
            transform: translateX(0px) translateY(-50%);
        }

        100% {
            top: 50%;
            -webkit-transform: translateX(5px) translateY(-50%);
            transform: translateX(5px) translateY(-50%);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/base/product-item.vue